/**
 * Switch Component - Constants
 * ============================
 */

export type SwitchSize = 'sm' | 'md';

export interface SwitchSizeStyles {
  track: string;
  knob: string;
  label: string;
}

export interface SwitchDefaultValues {
  size: SwitchSize;
}

export const SIZES: Record<SwitchSize, SwitchSizeStyles> = {
  sm: { track: 'ec-w-9 ec-h-5',  knob: 'ec-w-4 ec-h-4', label: 'ec-text-sm' },
  // md = spec Figma: track 40x24, knob 20px con inset 2px (ec-p-0.5 en BASE_CLASSES.track).
  md: { track: 'ec-w-10 ec-h-6', knob: 'ec-w-5 ec-h-5', label: 'ec-text-base' }
};

export const BASE_CLASSES = {
  wrapper: 'ec-inline-flex ec-items-center ec-gap-3 ec-cursor-pointer ec-select-none',
  wrapperDisabled: 'ec-cursor-not-allowed ec-opacity-60',
  input: 'ec-sr-only',
  track: 'ec-flex ec-items-center ec-rounded-full ec-p-0.5 ec-transition-colors ec-flex-shrink-0',
  trackOn: 'ec-bg-color-primary-light ec-justify-end',
  trackOff: 'ec-bg-gray-light ec-justify-start',
  trackFocused: 'ec-ring-2 ec-ring-color-primary ec-ring-offset-1',
  knob: 'ec-inline-block ec-rounded-full ec-shadow-sm ec-transition-colors',
  knobOn: 'ec-bg-color-primary',
  knobOff: 'ec-bg-gray',
  label: 'ec-text-color-text'
};

export const DEFAULTS: SwitchDefaultValues = { size: 'md' };
